import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PHONE_MASK, PHONE_PATTERN} from '../../global';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CustomerService} from '../../services/customer.service';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-promo-claim',
  templateUrl: './promo-claim.component.html',
  styleUrls: ['./promo-claim.component.scss']
})
export class PromoClaimComponent implements OnInit {
  codeError: boolean; //If code missing
  phoneMask = PHONE_MASK;
  displayLoader: boolean;
  name: string;
  appUrl: any = 'https://wahii.com/fuel';
  phone: string;
  validPhone: boolean;
  showLoader: boolean;

  constructor(private route: ActivatedRoute,
              private deviceService: DeviceDetectorService,
              private customerService: CustomerService,
              private shared: SharedService) {
  }

  ngOnInit() {
    let code = this.route.snapshot.queryParams['code'];
    if (!code) this.codeError = true;
    else {
      this.name = '';
      for (let c of code) {
        if (isNaN(parseInt(c, 10))) this.name += c;
      }
    }
  }

  claim(phone) {
    this.showLoader = true;
    let data = {
      promoCode: this.route.snapshot.queryParams['code'],
      phone: phone.match(/\d/g).join(''),
      countryCode: '+1'
    };
    this.customerService.claimPromo(data)
      .then(() => {
        this.showLoader = false;
        let device = this.deviceService.device;
        let os = this.deviceService.os;
        if (os.toLowerCase() == 'android') this.appUrl = 'intent://wahiibapp/#Intent;scheme=bapp;package=com.wahiiuser.app;end';
        if (os.toLowerCase() == 'ios') this.appUrl = 'https://wahii.com/ios';
        if (device.toLowerCase() == 'iphone' || device.toLowerCase() == 'ipad') this.appUrl = 'https://wahii.com/ios';
        let win = window.open(this.appUrl, '_self');
        win.focus();
      })
      .catch((response) => {
        let err = response.error;
        this.showLoader = false;
        this.shared.openErrorDialog({title: 'Error', body: err.errorMessage || 'Unexpected error'});
      });

  }

  phoneCheck(phone) {
    return this.validPhone = new RegExp(PHONE_PATTERN).test(phone);
  }
}
